<template>
     <el-dialog
     :visible.sync="dialogVisible"
     :title="title"
     width="50%"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="proForm" :model="proForm" :rules="proFormRules" label-width="110px">
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="工艺路线编号">
                            <el-input size="small" v-model="proForm.technologyCode" placeholder="输入工艺路线编号，忽略将自动生成" :readonly="mode == 'edit'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工艺路线名称" prop="technologyName">
                            <el-input size="small" v-model="proForm.technologyName" placeholder="输入工艺路线名称"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="工序列表">
                            <div style="border:1px solid #DCDFE6;">
                                <el-table
                                    size="small"
                                    :data="listData"
                                    highlight-current-row
                                    stripe
                                    style="width: 100%;"
                                    :header-cell-style="_headerStyle"
                                    >
                                    <el-table-column  prop="type" label="类型" width="200">
                                        <template slot-scope="scope">
                                            <el-radio-group v-model="scope.row.type" @change="changeType(scope.row)">
                                                <el-radio label="process">工序</el-radio>
                                                <el-radio label="technology">工艺路线</el-radio>
                                            </el-radio-group>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="工序/工艺路线" >
                                        <template slot-scope="scope">
                                          <!-- 工序 -->
                                            <el-select
                                                v-if="scope.row.type == 'process'"
                                                v-model="scope.row.processCode"
                                                clearable
                                                filterable
                                                placeholder="请选择"
                                                style="width:100%;"
                                                size="small"
                                                @change="changeProcess(scope.$index,scope.row)"
                                            >
                                                <el-option
                                                v-for="item in processList"
                                                :key="item.processCode"
                                                :label="item.processName"
                                                :value="item.processCode"
                                                ></el-option>
                                            </el-select>
                                            <!-- 工艺路线 -->
                                            <el-select
                                                v-if="scope.row.type == 'technology'"
                                                v-model="scope.row.technologyCode"
                                                clearable
                                                filterable
                                                placeholder="请选择"
                                                style="width:100%;"
                                                size="small"
                                            >
                                                <el-option
                                                v-for="item in technologyList"
                                                :key="item.technologyCode"
                                                :label="item.technologyName"
                                                :value="item.technologyCode"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="报工数配比" >
                                        <template slot-scope="scope">
                                            <el-input-number v-model="scope.row.coefficient" v-if="scope.row.type == 'process'" size="mini" controls-position="right" :min="1" :max="9999999999" label="请填写" style="width: 100%;"></el-input-number>
                                            <span v-if="scope.row.type == 1">-</span>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column label="技术要求" >
                                        <template slot-scope="scope">
                                            <el-input size="small" v-model="scope.row.name2" placeholder="请输入" v-if="scope.row.type == 'process'"></el-input>
                                            <span v-if="scope.row.type == 1">-</span>
                                        </template>
                                    </el-table-column> -->

                                    <el-table-column align="left" label="操作" width="50" fixed="right">
                                        <template slot-scope="scope">
                                            <el-tooltip content="删除">
                                                <el-button
                                                size="mini"
                                                type="danger"
                                                icon="el-icon-delete"
                                                circle
                                                @click="deleteRow(scope.$index, scope.row)"
                                                ></el-button>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div style="margin-left:10px;">
                                    <el-button size="small" type="text" icon="el-icon-circle-plus-outline" @click="add">添加一行</el-button>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { technologySave,technologyGetAll,processGetAll } from '@/api/basicData'
export default {
    name:'createProcessRouting',
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        userData:{
            type:Object,
            default:{},
        },
        mode:{
          type:String,
          default:''
        },
        editRow:{
            type:Object,
            default:{},
        },
    },
    watch:{
    },
    data(){
        return{
            dialogVisible: false,
            proForm:{
              technologyName:''
            },
            proFormRules:{
              technologyName: [{
                required: true,
                message: "请输入工艺路线名称",
                trigger: ['blur','change'],
            },] ,
            },
            listData:[],
            technologyList:[],
            processList:[],
            disabled:false,
            title:'创建工艺路线'
        }
    },
    created(){
      this.dialogVisible = true
      if(this.mode == 'view'){
        this.disabled = true
      }else if(this.mode == 'edit'){
        this.title = '编辑工艺路线'
        this.proForm = JSON.parse(JSON.stringify(this.editRow))
        this.listData = this.proForm.processList
      }
      this.technologyAll()
      this.processAll()
    },
    methods:{
      changeProcess(index,row){
        let data = this.processList.filter(item=>item.processCode == row.processCode);
        if(data.length > 0){
          row.coefficient = data[0].coefficient;
        }
      },
      // 查询所有工艺路线列表
      technologyAll(){
        technologyGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            if(res.data && res.data.length!=0){
              this.technologyList = res.data
            }
          }else{
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.$message.error(err)
        })
      },
      // 查询所有工序
      processAll(){
        processGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            if(res.data && res.data.length!=0){
              this.processList = res.data
            }
          }else{
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.$message.error(err)
        })
      },
      handleSave(){
        this.$refs.proForm.validate((valid) => {
            if (valid) {
              var data = JSON.parse(JSON.stringify(this.proForm))
              data.factoryId = this.userData.factoryId,
              data.processList = this.listData
              if(data.processList.length == 0){
                this.$message.error('工序列表不能为空')
                return false
              }else{
                data.processList.map(function(item){
                  if(item.type == 'process'){
                    item.processName = this.processList.filter(function(item2){
                      return item2.processCode == item.processCode
                    })[0].processName
                  }else{
                    item.technologyName = this.technologyList.filter(function(item2){
                      return item2.technologyCode == item.technologyCode
                    })[0].technologyName
                  }
                }.bind(this))
                technologySave(data).then(res => {
                  if(res.code == 200){
                    this.$message.success('保存成功')
                    this.$emit('done',{type:'save'})
                    this.dialogVisible = false;
                  }else{
                    this.$message.error(res.msg)
                  }
                }).catch(err => {
                  this.$message.error(err)
                })
              }
            }
        })
      },

      closeDialog(){
        this.$emit('done',{type:'cancle'})
      },
      deleteRow(index,row){
          if(this.listData){
              this.listData.splice(index,1);
          }
      },
      add(){
          let obj = {
              type:'process',
              processCode:'',
              technologyCode:'',
              coefficient:'',
              // name2:'',
          };
          this.listData.push(obj);
      },
      changeType(row){
        row.processCode = ''
        row.technologyCode = ''
        // row.name2 = ''
        row.coefficient = ''
      },
    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        /* height: 45vh; */
        max-height: 60vh;
        overflow-y: auto;
        overflow-x: hidden;
        /* padding: 0px 50px; */
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }

</style>



// WEBPACK FOOTER //
// src/views/basicData/processRouting/createProcessRouting.vue